import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  listStyles: () => client.get("/styles").then((r) => r.data),
  listImages: () => client.get("/images").then((r) => r.data),
  score: (imageIds) => client.post("/quiz/score", { image_ids: imageIds }).then((r) => r.data),
  captureEmail: (payload) => client.post("/results/email", payload).then((r) => r.data),
  admin: {
    list: () => client.get("/admin/images").then((r) => r.data),
    summary: () => client.get("/admin/summary").then((r) => r.data),
    update: (id, payload) => client.patch(`/admin/images/${id}`, payload).then((r) => r.data),
    upload: (formData) =>
      client
        .post("/admin/images/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((r) => r.data),
    remove: (id) => client.delete(`/admin/images/${id}`).then((r) => r.data),
  },
};

export const resolveImageUrl = (image) => {
  if (!image) return "";
  const url = image.url || "";
  if (url.startsWith("http")) return url;
  // Backend-relative path like /api/files/...
  return `${BACKEND_URL}${url}`;
};
